import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/cn';

const SIZE = { sm: 14, md: 18, lg: 24 } as const;

interface SpinnerProps {
  size?: keyof typeof SIZE;
  className?: string;
  /** Announce to screen readers. Omit when adjacent text already says it. */
  label?: string;
}

export function Spinner({ size = 'md', className, label }: SpinnerProps) {
  return (
    <Loader2
      size={SIZE[size]}
      className={cn('animate-spin', className)}
      role={label ? 'status' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    />
  );
}
